module.exports = __webpack_public_path__ + "img/sa.6837c71a.svg";